var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BaseComponent } from '../../../utils/BaseComponent';
let Page = class Page extends BaseComponent {
    constructor() {
        super(...arguments);
        this.first = false;
        this.last = false;
        this.hideContinue = false;
        this.verified = false;
    }
    render() {
        return html `
    <div class="flex flex-col md:w-[400px] md:h-[400px]">
      <div class="flex justify-between mb-16 text-center items-center">
        ${this.first ? nothing : html `<button
        class="w-32 h-32 button--round shrink-0 mt-2"
        @click=${() => {
            this.dispatchEvent(new CustomEvent('back', { bubbles: true, composed: true }));
        }}>
          <trust-icon classNames="w-16 h-16" name="BackArrow"></trust-icon>
        </button>`}
        ${this.first ? html `<h3 class="strong m-0">${this.header}</h3>` : html `
        <p class="strong m-0">${this.header}</p>`}
        <button
         class="w-32 h-32 button--round shrink-0 mt-2"
         @click=${() => {
            this.dispatchEvent(new CustomEvent('close', { detail: { clickedOverlay: false }, bubbles: true, composed: true }));
        }}>
          <trust-icon classNames="w-16 h-16" name="Close"></trust-icon>
        </button>
      </div>
      <slot class=${`${this.classNames} block h-full`}></slot>
      ${!this.hideContinue ? html `
         <div class="md:flex md:justify-end">
        ${!this.last ? html `
          <trust-button classNames="w-full mt-16 md:w-fit" primary dataTest="continue" autoFocus @click=${(e) => {
            if (this.verify()) {
                e.target.dispatchEvent(new CustomEvent('next', { bubbles: true, composed: true }));
            }
        }}> Fortsett </trust-button>
        ` : html `<trust-button classNames="w-full md:w-fit mt-16" primary dataTest="confirm" autoFocus @click=${(e) => {
            if (this.verify()) {
                this.dispatchEvent(new CustomEvent('confirm', { detail: { target: e.target }, bubbles: true, composed: true }));
            }
        }}> Send inn </trust-button>`}
        </div>
      ` : nothing}
    </div>
    `;
    }
};
__decorate([
    property()
], Page.prototype, "classNames", void 0);
__decorate([
    property()
], Page.prototype, "header", void 0);
__decorate([
    property({ type: Function })
], Page.prototype, "verify", void 0);
__decorate([
    property({ type: Boolean })
], Page.prototype, "first", void 0);
__decorate([
    property({ type: Boolean })
], Page.prototype, "last", void 0);
__decorate([
    property({ type: Boolean })
], Page.prototype, "hideContinue", void 0);
__decorate([
    state()
], Page.prototype, "verified", void 0);
Page = __decorate([
    customElement('trust-page')
], Page);
export { Page };
//# sourceMappingURL=page.js.map